const ACTIVE_CLASS = "active";

// Универсальный аккордеон. Высоту анимирует CSS (grid-template-rows,
// см. src/scss/components/_accordion.scss), JS только переключает active-класс.
//
// Минимальная разметка:
// <div data-accordion>                          контейнер; data-accordion="multiple" -
//   <div class="accordion__items">                          можно открыть несколько сразу
//     <div class="accordion__item box-border-gradient" data-accordion-item>
//       <h3 class="accordion__header">
//         <button class="accordion__button" type="button" data-accordion-button>
//           ...<svg class="accordion__toggle">...</svg>
//         </button>
//       </h3>
//       <div class="accordion__collapse">
//         <div class="accordion__collapse-in">контент</div>
//       </div>
//     </div>
//   </div>
// </div>
//
// Внешний вид тоже задают классы accordion__* (см. _accordion.scss),
// блок-владелец (например .section-faq) - только специфику места (ширину, отступы).
export const accordionInit = () => {
    document.querySelectorAll("[data-accordion]").forEach(($accordion) => {
        const isMultiple = $accordion.dataset.accordion === "multiple";
        const $items = Array.from($accordion.querySelectorAll("[data-accordion-item]"));

        const setOpen = ($item, isOpen) => {
            $item.classList.toggle(ACTIVE_CLASS, isOpen);

            const $button = $item.querySelector("[data-accordion-button]");

            if ($button) {
                $button.setAttribute("aria-expanded", isOpen ? "true" : "false");
            }
        };

        $items.forEach(($item) => {
            const $button = $item.querySelector("[data-accordion-button]");

            if (!$button) {
                return;
            }

            $button.addEventListener("click", () => {
                const isOpen = $item.classList.contains(ACTIVE_CLASS);

                if (!isMultiple) {
                    $items.forEach(($other) => setOpen($other, false));
                }

                setOpen($item, !isOpen);
            });
        });
    });
};
